import MiniCourseList from "./MiniCourseList";

export default MiniCourseList;
